import Vue from 'vue'
import { Tabs, TabPane, Tree } from 'element-ui'
import { Splitpanes, Pane } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons'
import { PrismEditor } from 'vue-prism-editor'

import Query from '@/components/Query'
import TableInfo from '@/components/TableInfo'
import SavedQueries from '@/components/SavedQueries'
import FileSystemExplorer from '@/components/FileSystemExplorer'
import CatalogViewer from '@/components/catalog/CatalogViewer'
import ColumnTreeItem from '@/components/catalog/ColumnTreeItem'
import CodeEditor from '@/components/editor/CodeEditor'

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */
Vue.component('icon', Icon)
Vue.component('prism-editor', PrismEditor)
Vue.component('a-query', Query)
Vue.component('a-table-info', TableInfo)
Vue.component('a-saved-queries', SavedQueries)
Vue.component('a-file-system-explorer', FileSystemExplorer)
Vue.component('a-catalog-viewer', CatalogViewer)
Vue.component('a-column-tree-item', ColumnTreeItem)
Vue.component('a-code-editor', CodeEditor)
Vue.component(Tree.name, Tree)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component('splitpanes', Splitpanes)
Vue.component('pane', Pane)



// WEBPACK FOOTER //
// ./src/components.js